import DateUtilsService from 'external-services/date-utils-service';
import AdminService from 'external-services/diary-admin-service/admin.service';
import {WHOLE_NUMBER_REGEX} from "appRoot/app.constants";

const NS = 'CreateServices';

const template = require('./createServices.html');

export default function CreateServices(
  $filter, pouchService, scheduleService, appConstants, unregister
) {
  "ngInject";

  return {
    scope: true,
    bindToController: {
      services: '=',
      schedule: '=',
      isDisabled: '=',
      covers: '=',
      displayErrors: '='
    },
    controller: function () {},
    link,
    controllerAs: 'vm',
    restrict: 'E',
    template
  };

  function link($scope) {

    var vm = $scope.vm;

    //-- define public properties
    vm.minBookingDuration = 30;
    vm.bookingIntervals = scheduleService.bookingIntervals;
    vm.serviceTypes = scheduleService.serviceTypes;
    vm.WHOLE_NUMBER_REGEX = WHOLE_NUMBER_REGEX;

    //-- define public methods
    vm.addService = addService;
    vm.deleteService = deleteService;
    vm.checkClose = checkClose;
    vm.checkDateDay = checkDateDay;

    //-- listen
    var listeners = [];
    listeners.push($scope.$watch('servicesForm.$valid', validUpdate));
    listeners.push($scope.$on('$destroy', () => unregister(listeners)));

    if (!vm.services.length) {
      addService();
    }

    function addService() {
      var lastService;
      if (vm.services.length) {
        lastService = vm.services[vm.services.length - 1];
      }
      const timezoneId = AdminService.getVenueTimezoneId();
      var startTime = DateUtilsService.getClearDate(null, timezoneId);
      startTime.setHours(8);
      var bookingDuration = 90;
      if (lastService) {
        // if there is a service before this one start right after it
        startTime = (lastService.endTime) ? lastService.endTime : startTime;
        bookingDuration = (lastService.bookingDuration) ? lastService.bookingDuration : bookingDuration;
      }
      var endTime = new Date(startTime.getTime());
      endTime.setHours(endTime.getHours() + 3);
      var lastBookingTime = new Date(endTime.getTime());
      lastBookingTime.setMinutes(lastBookingTime.getMinutes() - 15);

      vm.services.push({
        _id: Math.random(), // place holder id
        name: '',
        startTime: startTime,
        endTime: endTime,
        lastBookingTime: lastBookingTime,
        bookingDuration: bookingDuration,
        online: true,
        paymentDetails: {
          paymentType: appConstants.Payment.PaymentTypes.NoPayment,
          peopleRequired: 1
        }
      });
    }

    function checkDateDay(date, service, dateParam) {
      const timezoneId = AdminService.getVenueTimezoneId();
      var todaysDate = DateUtilsService.getVenueTime(timezoneId);
      service[dateParam] = DateUtilsService.checkDateDay(date, todaysDate);
    }

    function deleteService(index) {
      vm.services.splice(index, 1);
    }

    function checkClose(openDate, dataObj, closeParamName) {
      var closeStr = $filter('date')(dataObj[closeParamName], 'HH:mm');
      var closeDate = DateUtilsService.closeTimesToDate(closeStr, openDate);
      dataObj[closeParamName] = closeDate;
    }

    function validUpdate() {
      $scope.vm.isDisabled = !$scope.servicesForm.$valid;
    }

  }
}
